import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { StatusPill } from "./StatusPill";
import { BonusReceiptDialog } from "./BonusReceiptDialog";

// قائمة مكافآت الموظف: زر واحد بارز يفتح نافذة التأكيد الصريحة (نعم/لم أستلم).
export const MyBonusList = ({ rows, onChanged }) => {
  const { t } = useTranslation();
  const [active, setActive] = useState(null);

  if (!rows.length) {
    return (
      <NeuCard className="p-6 text-center text-sm text-muted-foreground" data-testid="my-bonus-empty">
        {t("bonus.mineEmpty")}
      </NeuCard>
    );
  }
  return (
    <div className="grid gap-3" data-testid="my-bonus-list">
      {rows.map((row) => (
        <NeuCard key={row.bonus_id} className="grid gap-2" data-testid={`my-bonus-${row.bonus_id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="num font-mono text-xs font-bold">{row.serial_number}</span>
            <StatusPill status={row.status} awaiting={row.awaiting_receipt}
                        confirmation={row.confirmation_status} received={row.received} />
          </div>
          <p className="num text-xl font-black">{row.amount} {row.currency}</p>
          <p className="text-xs text-muted-foreground">{row.reason}</p>
          <p className="text-xs">{t("bonus.fields.source")}: <b>{row.payment_source_name}</b></p>
          {row.awaiting_receipt ? (
            <NeuButton variant="primary" data-testid={`bonus-confirm-receipt-btn-${row.bonus_id}`}
                       className="flex items-center justify-center gap-2 py-3 font-black"
                       onClick={() => setActive(row)}>
              <CheckCircle2 className="h-4 w-4" /> {t("bonus.receipt.open")}
            </NeuButton>
          ) : null}
        </NeuCard>
      ))}
      {active ? (
        <BonusReceiptDialog
          bonus={active}
          onDone={() => {
            setActive(null);
            onChanged();
          }}
          onLater={() => setActive(null)}
        />
      ) : null}
    </div>
  );
};
